import { ROLE, Role } from '@common/components/RBAC';

/**
 * Checks if a user has one of the allowed roles.
 *
 * @param userRole - The role of the user to check.
 * @param allowedRoles - An array of allowed roles. Defaults to [Teacher, Mentor/Tutor].
 * @returns true if the user's role is in the list of allowed roles, otherwise false.
 */
function hasUserCorrectRole(
	userRoles: Role[] = [],
	allowedRoles: Role[] = [ROLE.TEACHER, ROLE.MENTOR_TUTOR, ROLE.CURATOR],
): boolean {
	return userRoles?.some((role) => allowedRoles.includes(role));
}

export default hasUserCorrectRole;
